import { genreOptions, regionOptions, yearOptions } from '@/mocks/movies';
import type { SortKey } from '@/utils/content';

export interface FilterState {
  genre: string;
  year: string;
  region: string;
  sort: SortKey;
}

interface FilterControlsProps {
  type: string;
  value: FilterState;
  onChange: (next: FilterState) => void;
}

const sortOptions: { key: SortKey; label: string }[] = [
  { key: 'latest', label: '最新' },
  { key: 'hot', label: '热门' },
  { key: 'rating', label: '评分' },
];

function OptionRow({
  label,
  options,
  current,
  onSelect,
}: {
  label: string;
  options: string[];
  current: string;
  onSelect: (option: string) => void;
}) {
  return (
    <div>
      <h4 className="mb-2.5 text-xs font-semibold uppercase tracking-wider text-secondary-500">{label}</h4>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => onSelect(option)}
            className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
              current === option
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterControls({ type, value, onChange }: FilterControlsProps) {
  const genres = genreOptions[type] ?? genreOptions.movie;

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h4 className="mb-2.5 text-xs font-semibold uppercase tracking-wider text-secondary-500">排序方式</h4>
        <div className="flex flex-wrap gap-2">
          {sortOptions.map((option) => (
            <button
              key={option.key}
              type="button"
              onClick={() => onChange({ ...value, sort: option.key })}
              className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
                value.sort === option.key
                  ? 'bg-accent-500 text-primary-950'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      <OptionRow
        label="类型"
        options={genres}
        current={value.genre}
        onSelect={(option) => onChange({ ...value, genre: option })}
      />
      <OptionRow
        label="年份"
        options={yearOptions}
        current={value.year}
        onSelect={(option) => onChange({ ...value, year: option })}
      />
      <OptionRow
        label="地区"
        options={regionOptions}
        current={value.region}
        onSelect={(option) => onChange({ ...value, region: option })}
      />
    </div>
  );
}